module.exports = __webpack_public_path__ + "static/furniture-banner-sale-section-code-12598c96c505c569b74fcb4f02f615e3.png";